import { render, staticRenderFns } from "./uuPay.vue?vue&type=template&id=0f98e6ae&scoped=true"
import script from "./uuPay.vue?vue&type=script&lang=js"
export * from "./uuPay.vue?vue&type=script&lang=js"
import style0 from "./uuPay.vue?vue&type=style&index=0&id=0f98e6ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f98e6ae",
  null
  
)

export default component.exports